<script setup lang="ts">
import { computed } from 'vue'
import { CheckboxGroup } from '@/shared/ui/CheckboxGroup'

const HOUR_OPTIONS = Array.from({ length: 24 }, (_, hour) => ({
  value: hour,
  label: `${String(hour).padStart(2, '0')}:00`
}))

/**
 * The hours of a day as 24 boxes, modelled as `number[]` of hours 0-23. `CheckboxGroup`
 * underneath speaks `Array<string | number>`; the numbers are restored on the way out, so
 * a form field stays numeric and needs no coercion of its own. `WeekdaysCheckboxes` is
 * the same idea over days, and the two pair up in a schedule.
 */
const props = withDefaults(
  defineProps<{
    modelValue?: number[]
    disabled?: boolean
  }>(),
  { modelValue: () => [] }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: number[]): void
}>()

const selected = computed(() => props.modelValue ?? [])

function onUpdate(value: Array<string | number>) {
  emit(
    'update:modelValue',
    value.map((item) => Number(item))
  )
}
</script>

<template>
  <CheckboxGroup
    :model-value="selected"
    :options="HOUR_OPTIONS"
    :disabled="disabled"
    :columns="6"
    @update:model-value="onUpdate"
  />
</template>
